// tslint:disable:max-line-length
import React from 'react';

export const ProductRnT = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M2 11C1.17157 11 0.5 10.3284 0.5 9.5V1.5C0.5 0.671573 1.17157 0 2 0C2.82843 0 3.5 0.671573 3.5 1.5L3.5 9.5C3.5 10.3284 2.82843 11 2 11Z" />
      <path d="M2 16C1.17157 16 0.5 15.3284 0.5 14.5C0.5 13.6716 1.17157 13 2 13C2.82843 13 3.5 13.6716 3.5 14.5C3.5 15.3284 2.82843 16 2 16Z" />
      <path d="M6.5 9.5C6.5 10.3284 7.17157 11 8 11C8.82843 11 9.5 10.3284 9.5 9.5L9.5 2.5C9.5 1.67157 8.82843 1 8 1C7.17157 1 6.5 1.67157 6.5 2.5L6.5 9.5Z" />
      <path d="M8 16C7.17157 16 6.5 15.3284 6.5 14.5C6.5 13.6716 7.17157 13 8 13H14C14.8284 13 15.5 13.6716 15.5 14.5C15.5 15.3284 14.8284 16 14 16H8Z" />
      <path d="M12.5 9.5C12.5 10.3284 13.1716 11 14 11C14.8284 11 15.5 10.3284 15.5 9.5V5.5C15.5 4.67157 14.8284 4 14 4C13.1716 4 12.5 4.67157 12.5 5.5V9.5Z" />
    </svg>
  );
};
